import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "../../../axios";

export const getVideos = () => ({ type: "GET_VIDEOS" })
export const getVideosRequest = () => ({ type: "GET_VIDEOS_REQUEST" })
export const getVideosSuccess = payload => ({ type: "GET_VIDEOS_SUCCESS", payload })
export const getVideosFailed = error => ({ type: "GET_VIDEOS_FAILED", error })

export function* getVideosSaga() {
    yield put(getVideosRequest())
    try {
        let { data: payload } = yield call(axios,"/videos")
        yield put(getVideosSuccess(payload))
    } catch(err){
        yield put(getVideosFailed(err))
    }
}

export default function* videosSagaWatcher() {
    yield takeEvery("GET_VIDEOS", getVideosSaga)
}